import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Auth from 'modules/Auth';

const Callback: React.FC = () => {
  const [redirectTo, setRedirectTo] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    let unmounted = false;

    const handleCallback = async (): Promise<void> => {
      if (!location.pathname.includes('auth-callback')) return;

      try {
        const { returnTo } = await Auth.authenticate();
        const intendedUrl = sessionStorage.getItem('intendedUrl');
        sessionStorage.removeItem('intendedUrl');
        if (!unmounted) {
          setRedirectTo(returnTo || intendedUrl || '/');
        }
      } catch {
        if (!unmounted) {
          setRedirectTo('/');
        }
      }
    };

    handleCallback();

    return () => {
      unmounted = true;
    };
  }, []);

  if (!redirectTo) {
    return <>Checking authentication</>;
  }

  return <Navigate to={redirectTo} replace />;
};

export default Callback;
